import React, { PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';

interface MainReviewsProps {
    title: string;
    className: string;
}

const MainReviews: React.FC<PropsWithChildren<MainReviewsProps>> = ({ title, children, className }): ReactElement => (
    <div className={classNames('reviews', className)}>
        <h2 className="reviews__title">
            {title}
        </h2>
        {children}
    </div>
);

export default MainReviews;
